import React from "react";
import styles from "../../../JobShiftPreStart/JobShiftPreStartView.module.css";
import { getReadinessChecklist } from "../../../JobShiftReadiness/sections/readinessQuestionsFormUtils";

const EMPTY_ROWS = ["sign-off-1", "sign-off-2", "sign-off-3"];

export default function EmergencyReadinessSignOffPreview({ readiness }) {
  const checklist = getReadinessChecklist(readiness);
  const headingContents = checklist.heading_contents && typeof checklist.heading_contents === "object"
    ? checklist.heading_contents
    : {};
  const signOffHeading = typeof headingContents.rescue_readiness_staff_signoff === "string"
    ? headingContents.rescue_readiness_staff_signoff
    : "";

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview} ${styles.readinessSectionNum}`}>4</span>
        Rescue Readiness Sign Off
      </div>
      <div className={styles.PreviewSectionBody}>
        <div className={styles.PreviewEditableHeading}>
          <div className={`${styles.PreviewRichText} preview-swms-v3-authorization-rich-text`} dangerouslySetInnerHTML={{ __html: signOffHeading }} />
        </div>
        <table className={styles.PreviewTable}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Name</th>
              <th>Role</th>
              <th>Phone</th>
              <th>Signature</th>
            </tr>
          </thead>
          <tbody>
            {EMPTY_ROWS.map((rowKey) => (
              <tr key={rowKey}>
                <td><p></p></td>
                <td><p></p></td>
                <td><p></p></td>
                <td><p></p></td>
                <td><p></p></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
